import { Button, H2 } from '@/components';
import { PublicArrowRightTail } from 'notta-web-icon';
import React from 'react';
import { PrivacyAuthLogoList } from '../../constants';
import * as styles from './index.module.less';

const Security = () => {
  return (
    <div className={styles.effect_privacy_layout}>
      <div className={styles.effect_privacy_container}>
        <H2>
          安心
          <wbr />の<wbr />
          セキュリティ体制
        </H2>
        <div className={styles.privacy_logos_container}>
          {PrivacyAuthLogoList.map((item, index) => {
            return (
              <div key={index} className={styles.auth_logo}>
                <img src={item.src} alt={item.alt} />
              </div>
            );
          })}
        </div>
        <div className={styles.privacy_link}>
          <a href="/security" data-gtm="home-page-security-btn">
            <Button type="link">
              「セキュリティ」への取り組みについて <PublicArrowRightTail size={18} />
            </Button>
          </a>
        </div>
      </div>
    </div>
  );
};
export default Security;
